@if (videoContent(); as content) {
  <parkour-video-content [content]="content" />
}
